import { ChevronRight } from "lucide-react";

export function BodyResultCard({ bodyResult, onNext }) {
  return (
    <div className="flex flex-col gap-6">
      <div className="bg-white rounded-2xl p-6 border border-stone-100 shadow-[0_8px_24px_rgba(28,25,23,0.05)]">
        <div className="text-[10px] font-[Manrope] font-bold tracking-[0.25em] uppercase text-[#6B7A54]">
          Your silhouette
        </div>
        <h3 className="mt-2 font-[Cormorant_Garamond] text-3xl capitalize italic text-stone-900">
          {bodyResult.body_type}
        </h3>
        <p className="mt-3 font-[Manrope] text-base text-stone-700 leading-relaxed">
          {bodyResult.body_notes}
        </p>
      </div>
      <button onClick={onNext} className="btn-primary">
        Looks good <ChevronRight size={16} strokeWidth={1.5} />
      </button>
    </div>
  );
}
